import { gql } from '@apollo/client/core';

export const GET_COURSE_REG_FINANCIAL_CLEARANCE = gql`
  query GetCourseRegistrationFinancialClearance {
    getCourseRegistrationFinancialClearance {
      required
      cleared
      outstanding_balance
      mode
      basis
      pegs {
        bill_id
        bill_label
        percentage_required
        percentage_achieved
        amount_required
        amount_counted
        cleared
      }
    }
  }
`;
